//HdcSheet: Handicap sheet for customer

import { A9Service } from 'components/system/angular';
import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system/data-provider';
import { RsHdcSheet, RsHdcSheetInfo } from './types';

export type ICustomerHandicapSheetDataProvider = IDataProviderV2<RsHdcSheet, RsHdcSheetInfo>;

@A9Service('customerHandicapSheetDataProvider')
export class CustomerHandicapSheetDataProvider extends AbstractDataProviderV2<RsHdcSheet, RsHdcSheetInfo> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/hdc-sheet');
    }
}
